import { Box, Grid, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { useCountdown } from '../../../../sharedComponents/src/hooks/useCountdown'
import { mainFont } from '../../../../sharedComponents/src/Theme/theme-v2'
import { Achievement } from '../../../MissionService/missionsTypes'
import { ClaimedMission } from './ClaimedMission'

type AchievementCardProps = {
    achievement: Achievement
}

export const AchievementCard: FC<AchievementCardProps> = ({ achievement }) => {
    const [hidden, setHidden] = useState(false)

    const timeLeft = useCountdown(achievement.expirationDate, () => {
        achievement.expirationDate && !hidden && setHidden(true)
    })

    if (hidden) return null

    return (
        <Grid item xs={4} sm={3} md={2} lg={2} key={achievement.missionId}>
            <ClaimedMission achievement={achievement} animated={Boolean(achievement.isNew)} />
            <Box height="68px">
                <Typography
                    variant="body2"
                    textAlign="center"
                    width="100%"
                    fontWeight="bold"
                    fontFamily={mainFont}
                    sx={{ mt: 1, fontSize: '16px' }}
                >
                    {achievement.tooltip}
                </Typography>
                {timeLeft && (
                    <Typography
                        color="text.disabled"
                        variant="body2"
                        textAlign="center"
                        fontWeight="bold"
                        sx={{ mt: 0.5 }}
                    >
                        Expires: {timeLeft}
                    </Typography>
                )}
            </Box>
        </Grid>
    )
}
